
import Vue, { PropType } from 'vue';
import CustomTool from './CustomTool.vue';
import { Tool, ToolSection } from '../../typings';

export default Vue.extend({
  components: {
    CustomTool,
  },
  props: {
    toolset: {
      type: [] as PropType<Tool[]>,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    activeInteractionMode: {
      type: String,
      default: 'auto',
    },
  },
  computed: {
    toolsBySection() {
      return this.toolset.reduce<ToolSection>((byGroup, tool) => {
        return {
          ...byGroup,
          [tool.section]: {
            ...byGroup[tool.section],
            [tool.group]: {
              value: (byGroup[tool.section]?.[tool.group]?.['value'] || [])
                // Disable each tool in a toolset, when toolset :is-disabled="true"
                .concat({ ...tool, disabled: this.isDisabled }),
            },
          },
        };
      }, {} as ToolSection);
    },
    sections(): string[] {
      return Object.keys(this.toolsBySection);
    },
  },
});
